<template>
  <DBox :id="'cmp-settings-custom-texts-template-editor'" :addButton="false">
    <div class="dt-list template-list">
      <div
        class="dt-list-item"
        v-for="templ of templates"
        :key="templ.template_id"
      >
        <div
          class="dt-list-item--body"
          :class="{
            selected:
              templ.template_id ==
              (selectedTemplate && selectedTemplate.template_id)
          }"
          @click="e => onTemplateClick(templ)"
          :title="templ.description"
        >
          <div class="dt-list-item--text">{{ templ.description }}</div>
        </div>
      </div>
    </div>
    <div class="template-item">
      <div class="template-title" v-if="selectedTemplate">
        {{ selectedTemplate.description }}
      </div>
      <div class="form-group" v-if="selectedTemplate">
        <TextField
          :id="'template_text'"
          v-bind="textFieldConfig"
          :value="selectedTemplate.template_text"
          :placeholder="$t('body_text')"
          textarea
          :height="500"
          @valuechanged="
            (name, value) =>
              onTemplateValueChange(name, value, selectedTemplate)
          "
        />
        <div class="available-datapoints">
          <b>{{$t('available_datapoints')}}</b>
          <div class="datapoints">{{ datapoints }}</div>
        </div>
      </div>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";

import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import {
  createTextFieldConfig,
  EventHooks
} from "../../../../plugins/text-field";
import { capitalizeFirst } from "../../../../utility";

export default {
  components: {
    DBox
  },
  props: ["custom_textsSettingsData"],
  data: function() {
    return {
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur
      }),
      selectedTemplate: null,
      template_key: "assistant_intelligence"
    };
  },
  watch: {
    custom_textsSettingsData: {
      immediate: true,
      handler: function(to, from) {
        if (!this.selectedTemplate) {
          this.selectedTemplate = this.templates?.[0];
        }
      }
    }
  },
  computed: {
    templates: function() {
      return (
        this.custom_textsSettingsData?.["assistant_intelligence"]?.templates ||
        []
      );
    },
    datapoints: function() {
      return {
        "Contract  Reminder":
          "[% start_date %], [% artists %], [% city %], [% booking_location_name %], [% contact_name %], [% contact_email %], [% contact_phone %], [% contact_mobile %]",
        "Invoice  Reminder":
          "[% invoice_subject %], [% invoice_address %], [% invoice_url %]",
        "Questionnaire Reminder":
          "[% start_date %], [% booking_location_name %], [% city %], [% artists %]",
        "Send Contract":
          "[% tart_date %], [% artists %], [% city %], [% booking_location_name %], [% contact_name %], [% contact_email %], [% contact_phone %], [% contact_mobile %], [% link %]"
      }[(this.selectedTemplate?.description)];
    }
  },
  methods: {
    onTemplateValueChange: function(name, value, item) {
      console.log({ item, name, value });
      this.$emit("updated", {
        item,
        name,
        value,
        template_key: this.template_key
      });
    },
    onTemplateClick: function(template) {
      this.selectedTemplate = template;
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-custom-texts-template-editor {
  display: flex;
  .template-list {
    flex: 1;
    height: 100%;
    overflow: auto;

    border-right: 1px solid var(--sprt-65);

    .dt-list-item {
      .dt-list-item--body {
        cursor: pointer;
        &:hover {
          font-weight: 500;
          text-decoration: underline;
        }
        &.selected,
        &:active {
          font-weight: 600;
          text-decoration: underline;
        }
      }
    }
  }
  .template-item {
    flex: 1;
    .template-title {
      // font-size: 14px;
      padding: 10px 15px 10px 15px;
      background: var(--bc-3);
    }
    .available-datapoints {
      padding: 10px 15px;
      background: var(--bc-3);

      .datapoints {
        margin-top: 5px;
      }
    }
  }
}
</style>
